import { IInstanceComponentBase, InstanceComponentBase } from "../../shared/instanceComponentBase";
import { AttributeEnums } from "../../shared/utilities/enums/attributeEnums";
import { CustomEventEnums } from "../../shared/utilities/enums/customEventEnums";
import { UtilityEnums } from "../../shared/utilities/enums/utillityEnums";
import { HelperUtils } from "../../shared/utilities/helperUtils";
import { ISelectableCarousel } from "../selectableCarousel/selectableCarousel";

export interface ICarouselGallery extends IInstanceComponentBase {
    carouselCurrentSelectedIndex: number;
    topLevelHtmlElement: HTMLElement; 
}

export abstract class CarouselGallery extends InstanceComponentBase implements ICarouselGallery {

    carouselCurrentSelectedIndex: number;
    public topLevelHtmlElement: HTMLElement; 
    private readonly _updateCarouselCurrentSelectedIndexFromEvent;
    constructor(public htmlElement: Element, 
                public carouselOrientation: UtilityEnums.ComponentOrientation, 
                public singleCarouselOrientation: UtilityEnums.ComponentOrientation, 
                topLevelHtmlElement?: HTMLElement) {
        super(htmlElement);

        if(topLevelHtmlElement !== undefined){
            this.topLevelHtmlElement = topLevelHtmlElement;
        } else{
            this.topLevelHtmlElement = this.htmlElement as HTMLElement;
        }
        this._updateCarouselCurrentSelectedIndexFromEvent = this.updateCarouselCurrentSelectedIndexFromEvent.bind(this);
        this.attachSelectedCarouselCellSelectedEventListener();
    }
    attachSelectedCarouselCellSelectedEventListener(): void {
        console.log('SelectableCarousel: attachSelectedCarouselCellSelectedEventListener');
        this.topLevelHtmlElement.addEventListener(CustomEventEnums.SelectedCarouselCellSelected, this._updateCarouselCurrentSelectedIndexFromEvent);
    }

    removeSelectedCarouselCellSelectedEventListener(): void {
        console.log('SelectableCarousel: removeSelectedCarouselCellSelectedEventListener');
        this.htmlElement.removeEventListener(CustomEventEnums.SelectedCarouselCellSelected, this._updateCarouselCurrentSelectedIndexFromEvent);
    }

    updateCarouselCurrentSelectedIndexFromEvent(event: CustomEvent) {
        console.log('SelectableCarousel: updateCarouselCurrentSelectedIndexFromEvent - event', event);
        const selectedIndex: number = event.detail.selectedIndex as number;
        this.updateCarouselCurrentSelectedIndex(selectedIndex);
    }
    updateCarouselCurrentSelectedIndex(index: number) {
        this.carouselCurrentSelectedIndex = index;
    }

    //------ Custom Event Creation Start -----//

    dispose() {
        this.removeSelectedCarouselCellSelectedEventListener();
        this.delete();
    }
    delete(): void {
        console.log('Gallery: delete');
    }
}